/**
 * Finds and replaces all occurrences of the WP URL with the current location
 * origin. This should be used for all AJAX calls to ensure the correct URLs are
 * being served. BrowserSync does this find/replace on the initial request but
 * doesn't catch all AJAX cases.
 * @param {string} data - input data
 * @returns {string} transformed data
 */
export function postAjaxCleanup(data) {
  const bs = window.___browserSync___

  if (bs === undefined || location === undefined) {
    return data
  }

  const regex = /(https?:)?\/\/(msunlocked\.local|(unlocked\.microsoft|unlocked(dev|test|prod)\.wpengine)\.com)/g
  return data.replaceAll(regex, location.origin)
}
